import { Nav } from "@/components/navigation/Navbar";
import { useRouter } from "next/router";
import * as Text from "@/components/text";
import qs from "qs";
import PosterCard from "@/components/film/PosterCard";
import apiClient from "@/utils/apiClient";
import FeatureTitlesContainer from "@/components/catalog/FeatureTitlesContainer";
// Import Swiper styles
import "swiper/css";

import { motion } from "framer-motion";
import RelatedMovies from "@/components/movies/RelatedMovies";
import TodayShows from "@/components/catalog/TodayShows";
import SearchBarCatalog from "@/components/catalog/SearchBarCatalog";
import Crumbs from "@/components/navigation/Crumbs";

import Link from "next/link";
import Filter, { MobileFilter } from "@/components/forms/FilmsFilter";
import ScrollHiderWrapper from "@/components/animation/ScrollHiderWrapper";
import RadioFilterList from "@/components/lib/RadioFilterList";
import { useState } from "react";
import { XIcon } from "@heroicons/react/solid";
import useWindowSize from "@/hooks/useWindowSize";
import ReactPaginate from "react-paginate";
import breakpoints from "@/constants/breakpoinst";

export default function Catalog({
  catalog,
  featured,
  themes,
  searchMovies,
  searchMeta,
}) {
  const [filterType, setFilterType] = useState("filters");
  const router = useRouter();
  const [keyword, setKeyword] = useState("");
  const { width } = useWindowSize();

  const handleRemoveQueryParam = (param, index) => {
    const query = { ...router.query };

    if (Array.isArray(query[param])) {
      if (index !== undefined) {
        query[param].splice(index, 1);
      } else {
        delete query[param];
      }
    } else {
      delete query[param];
    }

    router.push({
      pathname: router.pathname,
      query,
    });
  };

  return (
    <section key="catalogo-index">
      <ScrollHiderWrapper className="bg-white" scrollYAmount={-80}>
        <div className="border-b-2 ">
          <div className="amb-container">
            <Nav className="bg-gray-100 grow" theme="light" />
          </div>
        </div>
        <section className="sm:mx-4 md:mx-8 lg:mx-28 xl:mx-auto xl:max-w-[1208px]">
          <div className="flex flex-row gap-2 py-4 ">
            <Crumbs
              breadcrumbs={[
                { href: "/", text: "Inicio" },
                { href: "/catalogo", text: "Catálogo" },
              ]}
            />
          </div>
          <section className="flex items-center gap-3 py-2">
            <div className="sm:hidden lg:block">
              <RadioFilterList standAlone={true} />
            </div>
            <div className="w-full ">
              <SearchBarCatalog setKeyword={setKeyword} hidePreview={false} />
            </div>
            <div className="items-center hidden gap-3 lg:flex">
              <Filter />
            </div>
            <div className="lg:hidden">
              <MobileFilter
                filterType={filterType}
                setFilterType={setFilterType}
                selectedThemes={router?.query?.temas}
              />
            </div>
          </section>
        </section>
      </ScrollHiderWrapper>

      <section className="bg-white sm:mt-44 md:mt-44 lg:mt-60">
        <div className="flex flex-wrap gap-3 amb-container">
          {Object.keys(router.query).length
            ? Object.keys(router.query)
              .filter((k) => k !== "page" && k !== "iniciativa")
              .map((t, i) => (
                <div key={i} className="flex gap-3">
                  {Array.isArray(router.query[t]) ? (
                    router.query[t].map((value, index) => (
                      <div
                        key={`${t}-${index}`}
                        className="flex items-center px-3 rounded-full bg-neutral-100"
                      >
                        <Text.Body
                          as="p"
                          className="w-max text-neutral-900"
                          size="lg"
                        >
                          {t === "years" ? "Año de producción " : null}
                          {value}
                        </Text.Body>&nbsp;
                        <XIcon
                          className="flex w-4 h-4 ml-2 rounded-full cursor-pointer hover:bg-black hover:text-white"
                          onClick={() => handleRemoveQueryParam(t, index)}
                        ></XIcon>
                      </div>
                    ))
                  ) : (
                    <div className="flex items-center px-3 rounded-full bg-neutral-100">
                      <Text.Body
                        as="p"
                        className="w-max text-neutral-900"
                        size="lg"
                      >
                        &nbsp;
                        {t === "years" ? "Año de producción " : null}
                        {router.query[t]}
                      </Text.Body>&nbsp;
                      <XIcon
                        className="flex w-4 h-4 ml-2 rounded-full cursor-pointer hover:bg-black hover:text-white"
                        onClick={() => handleRemoveQueryParam(t)}
                      ></XIcon>
                    </div>
                  )}
                </div>
              ))
            : null}
        </div>
      </section>

      {searchMovies ? (
        <div className="pb-4 space-y-5 amb-container">
          <div>
            <Text.Headline className="mb-4">
              Resultados de búsqueda
            </Text.Headline>
          </div>
          <div>
            {searchMeta && (
              <Text.Body size="xl">
                {searchMeta.pagination.page * searchMeta.pagination.pageSize -
                  searchMeta.pagination.pageSize}&nbsp;
                - {searchMeta.pagination.page * searchMeta.pagination.pageSize}&nbsp;
                de {searchMeta.pagination.total}
              </Text.Body>
            )}
          </div>

          <div className="gap-4 md:grid md:grid-cols-2 lg:grid-cols-4">
            {searchMovies?.map((movie) => (
              <PosterCard
                key={movie.id}
                grid_details={true}
                theme="light"
                slug={`/catalogo/${movie.attributes.filmSlug}`}
                film_name={movie.attributes.film_name}
                film_image={
                  movie.attributes?.film_cover_image.data?.attributes.formats
                    .small?.url ||
                  movie.attributes?.film_cover_image.data?.attributes.url
                }
                film_link={movie.attributes.film_stream_link || ""}
                // film_original_title={movie.film_original_title || movie.film_name}
                film_directors={movie.attributes.Directores.map(
                  ({ Director }) => Director
                )}
                film_synopsis={movie.attributes.film_excerpt}
                film_streaming_link={movie.attributes.film_stream_link || ""}
              // film_metadata={{
              //   // year: movie.film_year[0] ? movie.film_year[0].year : null,
              //   duration: movie.film_length || "",
              //   countries: [movie.countries.map((c) => c.countries).join(", ")],
              // }}
              />
            ))}
          </div>

          {searchMeta.pagination.pageCount > 1 && (
            <ReactPaginate
              previousLabel={"Anterior"}
              nextLabel={"Siguiente"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              onPageChange={(event) => {
                router.push({
                  pathname: "/catalogo",
                  query: {
                    ...router.query,
                    page: event.selected + 1,
                  },
                });
              }}
              marginPagesDisplayed={width > breakpoints.md ? 3 : 1}
              pageCount={searchMeta.pagination.pageCount}
              containerClassName={
                "flex justify-center gap-5 mt-10 items-center"
              }
              pageClassName={
                "text-neutral-900 bg-neutral-50 hover:bg-neutral-100 w-12 h-12 flex items-center text-center"
              }
              activeClassName={"border-2 border-black"}
              pageLinkClassName={
                "w-full h-full flex items-center justify-center"
              }
              previousClassName={
                "text-neutral-900 bg-neutral-50 hover:bg-neutral-100 px-5 h-12 flex items-center text-center"
              }
              nextClassName={
                "text-neutral-50 bg-neutral-900 hover:bg-neutral-800 px-5 h-12 flex items-center text-center"
              }
            />
          )}
        </div>
      ) : (
        <section>
          <Text.Display
            className={
              "sm:mx-4 sm:my-4 sm:text-[24px] md:mx-8 md:my-4 md:text-[24px] lg:mx-[116px] lg:text-[28px] xl:mx-auto xl:max-w-[1208px]"
            }
            as="h3"
            size="sm"
          >
            Explora los títulos que han pasado por Ambulante
          </Text.Display>
          <div className="xl:mx-auto">
            <FeatureTitlesContainer featured={featured.data} />
          </div>

          <div className="my-10">
            <TodayShows />
          </div>

          <div className="sm:ml-4 sm:mt-12 md:ml-6 lg:mx-[116px] xl:mx-auto xl:max-w-[1208px]">
            {Object.keys(themes).map((themeName) => (
              <motion.div
                initial={{ opacity: 1 }}
                whileInView={{ opacity: 1, transition: { duration: 1 } }}
                key={themeName}
              >
                <RelatedMovies
                  simple={true}
                  titleLayout="flex  items-center justify-between sm:mr-4 md:mr-4"
                  films={themes[themeName]?.peliculas?.data || []}
                  themeName={themeName}
                  themeDescription={themes[themeName]?.description}
                />
              </motion.div>
            ))}
          </div>

          <section className="flex justify-center sm:ml-4 sm:mt-12 md:ml-6 lg:mx-[116px] xl:mx-auto xl:max-w-[1208px]">
            <Link href="/catalogo?iniciativa=todas-las-iniciativas">
              <button className="font-semibold border-b-2">
                Ver todas las películas
              </button>
            </Link>
          </section>
        </section>
      )}

    </section>
  );
}

export async function getServerSideProps(context) {
  const { query: q } = context;

  if (
    q?.temas ||
    q?.years ||
    q?.generaciones ||
    q?.eap ||
    q?.iniciativa ||
    q?.secciones ||
    q?.pais ||
    q?.keyword
  ) {
    const filterQuery = qs.stringify({
      populate: "*",
      filters: {
        $and: [
          (q?.temas && q?.temas === "Películas mexicanas") ||
            q?.temas === "Películas en línea"
            ? {
              "Películas mexicanas": {
                realizadores_mexicanos: {
                  $eq: true,
                },
              },
              "Películas en línea": {
                film_stream_link: {
                  $ne: null,
                },
              },
            }[q?.temas]
            : {
              temas: {
                name: {
                  $in: q.temas,
                },
              },
            },
          q?.pais && {
            countries: {
              countries: {
                $in: q.pais,
              },
            },
          },
          q?.keyword && {
            $or: [
              { Directores: { Director: { $containsi: q.keyword } } },
              { film_name: { $containsi: q.keyword } },
            ],
          },
          q?.secciones && {
            secciones: {
              name: {
                $in: q.secciones,
              },
            },
          },
          q?.years && {
            film_year: {
              year: {
                $in: q.years,
              },
            },
          },
          q?.generaciones && {
            ama_generacion: {
              ama_title: {
                $eqi: q.generaciones,
              },
            },
          },
          q?.eap && {
            ediciones_ambulante_presenta: {
              name: {
                $in: q.eap,
              },
            },
          },
          q?.iniciativa && {
            iniciativas: {
              slug: {
                $in:
                  q.iniciativa === "todas-las-iniciativas"
                    ? [
                      "gira-ambulante",
                      "ambulante-mas-alla",
                      "ambulante-presenta",
                    ]
                    : [q.iniciativa],
              },
            },
          },
          {
            ediciones_giras: {
              name: {
                $eq: q.egira,
              },
            },
          },
        ],
      },
      pagination: {
        page: q?.page || 1,
      },
    });

    const query = qs.stringify(
      {
        populate: {
          peliculas: {
            populate: {
              film_cover_image: "*",
              Directores: "*",
              countries: "*",
              iniciativas: "*",
              film_year: "*",
              awards: "*",
            },
          },
          temas_destacados: {
            populate: {
              tema_1: {
                populate: {
                  peliculas: {
                    populate: "*",
                  },
                },
              },
              tema_2: {
                populate: {
                  peliculas: {
                    populate: "*",
                  },
                },
              },
              tema_3: {
                populate: {
                  peliculas: {
                    populate: "*",
                  },
                },
              },
            },
          },
          idiomas: "*",
        },
      },
      { encodeValuesOnly: true }
    );

    const {
      data: { data: searchMovies, meta },
    } = await apiClient.get(`/api/films?${filterQuery}`);

    const {
      data: { data },
    } = await apiClient.get(`/api/catalogo?${query}`);

    return {
      props: {
        searchMovies,
        searchMeta: meta,
        catalog: data.attributes,
        featured: data.attributes.peliculas,
      },
    };
  } else {
    const query = qs.stringify(
      {
        populate: {
          peliculas: {
            populate: {
              film_cover_image: "*",
              Directores: "*",
              countries: "*",
              iniciativas: "*",
              film_year: "*",
              awards: "*",
            },
          },
          temas_destacados: {
            populate: {
              tema_1: {
                populate: {
                  peliculas: {
                    populate: "*",
                  },
                },
              },
              tema_2: {
                populate: {
                  peliculas: {
                    populate: "*",
                  },
                },
              },
              tema_3: {
                populate: {
                  peliculas: {
                    populate: "*",
                  },
                },
              },
            },
          },
          idiomas: "*",
        },
      },
      { encodeValuesOnly: true }
    );

    const onlineMoviesQuery = qs.stringify(
      {
        populate: "*",
        filters: {
          film_stream_link: {
            $ne: null,
          },
        },
        pagination: {
          limit: 6,
        },
      },
      { encodeValuesOnly: true }
    );

    const mexicanCreatorsQuery = qs.stringify(
      {
        populate: "*",
        filters: {
          realizadores_mexicanos: {
            $eq: true,
          },
        },
        pagination: {
          limit: 6,
        },
      },
      { encodeValuesOnly: true }
    );

    const {
      data: { data },
    } = await apiClient.get(`/api/catalogo?${query}`);

    const { show_mexican_movies, show_online_movies } = data.attributes;

    const {
      data: { data: mexicanMovies },
    } = await apiClient.get(`/api/films?${mexicanCreatorsQuery}`);
    const {
      data: { data: onlineMovies },
    } = await apiClient.get(`/api/films?${onlineMoviesQuery}`);

    const themes = {
      ...(data.attributes.temas_destacados.tema_1.data && {
        [data.attributes.temas_destacados.tema_1.data.attributes.name]:
          data.attributes.temas_destacados.tema_1.data.attributes,
      }),
      ...(data.attributes.temas_destacados.tema_2.data && {
        [data.attributes.temas_destacados.tema_2.data.attributes.name]:
          data.attributes.temas_destacados.tema_2.data.attributes,
      }),
      ...(data.attributes.temas_destacados.tema_3.data && {
        [data.attributes.temas_destacados.tema_3.data.attributes.name]:
          data.attributes.temas_destacados.tema_3.data.attributes,
      }),
      ...(show_mexican_movies && {
        "Películas mexicanas": {
          peliculas: {
            data: mexicanMovies,
          },
        },
      }),
      ...(show_online_movies && {
        "Películas en línea": {
          peliculas: {
            data: onlineMovies,
          },
        },
      }),
    };

    return {
      props: {
        catalog: data.attributes,
        featured: data.attributes.peliculas,
        themes,
      },
    };
  }
}
